import { useEffect, useState } from 'react'
import { RefreshCw, X } from 'lucide-react'
import { onSwUpdate, applySwUpdate } from '@/sw-register'
import { useUi } from '@/state/ui'

/**
 * "New version ready" as a floating pill above the tab bar (bottom-centre on
 * desktop). One tap to reload; dismissable. Never auto-reloads while you can
 * see it (sw-register swaps builds when the app is in the background instead)
 * and stays out of the way while quick-add is open.
 */
export const UpdateChip = () => {
  const [ready, setReady] = useState(false)
  const [busy, setBusy] = useState(false)
  const [dismissed, setDismissed] = useState(false)
  const quickAdd = useUi((s) => s.quickAddOpen)
  useEffect(() => onSwUpdate(() => setReady(true)), [])
  if (!ready || dismissed || quickAdd) return null
  return (
    <div
      className="fixed z-30 left-1/2 -translate-x-1/2 bottom-[calc(var(--above-tabbar)+1.25rem)] md:bottom-6 w-[calc(100%-1.5rem)] max-w-sm fade-in"
      role="status"
      data-testid="update-chip"
    >
      <div className="flex items-center gap-3 rounded-2xl bg-panel/95 backdrop-blur-md border border-line pl-4 pr-2 py-2 shadow-[var(--shadow-pop)]">
        <RefreshCw size={16} className={busy ? 'animate-spin text-accent' : 'text-accent'} aria-hidden />
        <div className="flex-1 min-w-0 leading-tight">
          <div className="text-sm font-medium">New version ready</div>
          <div className="text-xs text-muted">Your work is saved.</div>
        </div>
        <button
          type="button"
          className="shrink-0 rounded-xl bg-accent text-on-accent text-sm font-medium px-3.5 min-h-9 disabled:opacity-60 active:scale-95 transition-transform"
          disabled={busy}
          onClick={() => {
            setBusy(true)
            void applySwUpdate()
          }}
          data-testid="update-now"
        >
          {busy ? 'Updating…' : 'Update'}
        </button>
        <button
          type="button"
          className="shrink-0 h-9 w-9 rounded-xl text-muted hover:text-fg flex items-center justify-center"
          onClick={() => setDismissed(true)}
          aria-label="Not now"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  )
}
